export default function ResourcesHero() {
  return (
    <section className="relative py-20 bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/a463e72ed85b06bafc61ab584a5027fe.jpg')`
        }}
      ></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Financial Education <span className="text-orange-400">Resources</span>
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
          Expert insights, guides, and articles to help you understand debt settlement, 
          improve your financial health, and make informed decisions about your future.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => {
              document.querySelector('#articles')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap"
          >
            Browse Articles
          </button>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-3 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap"
          >
            Get Expert Help
          </button>
        </div>
      </div>
    </section>
  );
}